// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1BueI","select":"Header_select__3iUNH","clinic":"Header_clinic__24W_5"};